import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNowStrict } from 'date-fns';
import './widget-items.scss';
import Tooltip from '@atlaskit/tooltip';

interface QuoteWidgetItemType {
  url: string;
  timestamp: number;
  metadata?: {
    quoteNumber: string;
    fromQuote: string;
  };
  entityName?: string;
}
/**
 * Component for Quote Widget on the Search page
 * @constructor
 */
const QuoteWidgetItemsComponent = ({ url, timestamp, metadata }: QuoteWidgetItemType) => {
  return (
    <div className="flex justify-space-between pv-12 quote-widget-item">
      <div className="left-side">
        <div className="content">
          <Link to={url}>
            <div className="flex">
              <Tooltip content={metadata?.quoteNumber} position="bottom-start" tag="span">
                <div className="title">{metadata?.quoteNumber}</div>
              </Tooltip>
            </div>
          </Link>
        </div>
        <div className="content">
          <div className="sub-title">{metadata?.fromQuote}</div>
        </div>
      </div>
      <div className="right-side">
        <div className="content">
          <div className="timestamp">{formatDistanceToNowStrict(new Date(timestamp), { addSuffix: true })}</div>
        </div>
      </div>
    </div>
  );
};

export const QuoteWidgetItem = React.memo(QuoteWidgetItemsComponent);
